import { c as _c } from "react/compiler-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import React, { useMemo } from "react";
import { selectRuntimeData } from "#/features/callstack/model/callstackSlice";
import { useAppSelector } from "#/store/hooks";
export const BenchmarkChart: React.FC = () => {
  const $ = _c(42);
  const theme = useTheme();
  const {
    benchmarkResults
  } = useAppSelector(selectRuntimeData);
  benchmarkResults?.results;
  let t0;
  if ($[0] !== benchmarkResults?.results) {
    t0 = benchmarkResults?.results?.toSorted(_temp);
    $[0] = benchmarkResults?.results;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sortedRuntimes = t0;
  let t1;
  if ($[2] !== benchmarkResults?.results) {
    t1 = () => benchmarkResults?.results?.map(_temp2) ?? [];
    $[2] = benchmarkResults?.results;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  benchmarkResults?.results;
  let t2;
  if ($[4] !== t1) {
    t2 = t1();
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const xAxisData = t2;
  if (!benchmarkResults?.results) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Typography>No data</Typography>;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== xAxisData) {
    t3 = [{
      data: xAxisData,
      scaleType: "point" as const,
      label: "Iteration"
    }];
    $[7] = xAxisData;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      label: "Runtime (ms)"
    }];
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = {
      xAxis: t3,
      yAxis: t4
    };
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const commonAxisConfig = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center"
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography variant="subtitle2" sx={{
      alignSelf: "flex-start"
    }}>Runtime by execution order</Typography>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== benchmarkResults.results || $[15] !== theme.palette.primary.light) {
    t8 = [{
      data: benchmarkResults.results,
      showMark: false,
      area: true,
      connectNulls: true,
      valueFormatter: _temp3,
      color: theme.palette.primary.light
    }];
    $[14] = benchmarkResults.results;
    $[15] = theme.palette.primary.light;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: "100%"
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== commonAxisConfig.xAxis || $[19] !== commonAxisConfig.yAxis || $[20] !== t8) {
    t10 = <LineChart series={t8} xAxis={commonAxisConfig.xAxis} yAxis={commonAxisConfig.yAxis} desc="Benchmark chart" height={300} sx={t9} />;
    $[18] = commonAxisConfig.xAxis;
    $[19] = commonAxisConfig.yAxis;
    $[20] = t8;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Typography variant="subtitle2" sx={{
      alignSelf: "flex-start"
    }}>Runtime distribution (sorted)</Typography>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== sortedRuntimes) {
    t12 = sortedRuntimes ?? [];
    $[23] = sortedRuntimes;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== theme.palette.secondary.light) {
    t13 = [{
      data: t12,
      showMark: false,
      area: true,
      connectNulls: true,
      valueFormatter: _temp4,
      color: theme.palette.secondary.light
    }];
    $[25] = t12;
    $[26] = theme.palette.secondary.light;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== sortedRuntimes) {
    t14 = sortedRuntimes ?? [];
    $[28] = sortedRuntimes;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = t14.map(_temp5);
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15) {
    t16 = [{
      data: t15,
      scaleType: "point" as const,
      label: "Sample index"
    }];
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      width: "100%"
    };
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== commonAxisConfig.yAxis || $[36] !== t13 || $[37] !== t16) {
    t18 = <LineChart series={t13} xAxis={t16} yAxis={commonAxisConfig.yAxis} desc="Benchmark chart" height={300} sx={t17} />;
    $[35] = commonAxisConfig.yAxis;
    $[36] = t13;
    $[37] = t16;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t10 || $[40] !== t18) {
    t19 = <Box sx={t6}>{t7}{t10}{t11}{t18}</Box>;
    $[39] = t10;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
function _temp(a, b) {
  return a - b;
}
function _temp2(_, i) {
  return i;
}
function _temp3(v) {
  return v?.toFixed(24) ?? "";
}
function _temp4(v_0) {
  return v_0?.toFixed(24) ?? "";
}
function _temp5(__0, i_0) {
  return i_0;
}